(() => {
  'use strict';

  /* =========================================================
     EMPUREO CART DRAWER
  ========================================================= */

  let drawer = null;
  let cartUpdating = false;
  let addToCartUpdating = false;


  /* =========================================================
     GET DRAWER
  ========================================================= */

  function getDrawer() {
    if (!drawer || !document.body.contains(drawer)) {
      drawer = document.getElementById('EmpCartDrawer');
    }

    return drawer;
  }


  /* =========================================================
     SHOPIFY ROOT
  ========================================================= */

  function shopifyRoot() {
    return window.Shopify?.routes?.root || '/';
  }


  /* =========================================================
     ESCAPE HTML
  ========================================================= */

  function escapeHTML(value) {
    if (value === null || value === undefined) {
      return '';
    }

    const div = document.createElement('div');

    div.textContent = String(value);

    return div.innerHTML;
  }


  /* =========================================================
     FORMAT MONEY
  ========================================================= */

  function formatMoney(cents) {
    cents = Number(cents || 0);

    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      return window.Shopify.formatMoney(
        cents,
        window.Shopify.money_format || '£{{amount}}'
      );
    }

    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-GB',
      {
        style: 'currency',
        currency:
          window.Shopify?.currency?.active || 'GBP'
      }
    ).format(cents / 100);
  }


  /* =========================================================
     OPEN DRAWER
  ========================================================= */

  function openCartDrawer() {
    const cartDrawer = getDrawer();

    if (!cartDrawer) {
      console.error(
        'EmpCartDrawer not found.'
      );

      return false;
    }

    cartDrawer.classList.add('is-open');

    cartDrawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.documentElement.classList.add(
      'emp-cart-open'
    );

    document.body.classList.add(
      'emp-cart-open'
    );

    return true;
  }


  /* =========================================================
     CLOSE DRAWER
  ========================================================= */

  function closeCartDrawer() {
    const cartDrawer = getDrawer();

    if (!cartDrawer) {
      return;
    }

    cartDrawer.classList.remove(
      'is-open'
    );

    cartDrawer.setAttribute(
      'aria-hidden',
      'true'
    );

    document.documentElement.classList.remove(
      'emp-cart-open'
    );

    document.body.classList.remove(
      'emp-cart-open'
    );
  }


  /* =========================================================
     UPDATE HEADER CART COUNT
  ========================================================= */

  function updateCartCount(cart) {
    const count = Number(
      cart?.item_count || 0
    );


    document
      .querySelectorAll('.emp-cart-count')
      .forEach((badge) => {

        badge.textContent =
          count > 0 ? count : '';

        badge.style.display =
          count > 0 ? '' : 'none';

      });


    document
      .querySelectorAll('[data-cart-count]')
      .forEach((element) => {

        element.textContent =
          count > 0
            ? `(${count})`
            : '';

      });


    document
      .querySelectorAll('[data-cart-item-count]')
      .forEach((element) => {

        element.textContent = count;

      });
  }


  /* =========================================================
     GET IMAGE URL
  ========================================================= */

  function getCartImage(item) {
    if (!item) {
      return '';
    }

    let image = '';


    if (typeof item.image === 'string') {
      image = item.image;
    }


    if (!image && typeof item.featured_image === 'string') {
      image = item.featured_image;
    }


    if (
      !image &&
      item.featured_image &&
      typeof item.featured_image === 'object'
    ) {
      image =
        item.featured_image.url ||
        item.featured_image.src ||
        '';
    }


    if (
      !image &&
      item.product &&
      item.product.featured_image
    ) {
      image =
        typeof item.product.featured_image === 'string'
          ? item.product.featured_image
          : item.product.featured_image.url || '';
    }


    return image;
  }


  /* =========================================================
     GET PRODUCT URL
  ========================================================= */

  function getCartItemURL(item) {
    if (!item) {
      return '#';
    }

    let url =
      item.url ||
      item.product_url ||
      '';


    if (!url && item.product_id) {
      url = `/products/${item.handle || ''}`;
    }


    if (!url) {
      return '#';
    }


    /*
     * Make relative Shopify URLs safe.
     */

    if (
      url.startsWith('/') &&
      !url.startsWith('//')
    ) {
      return url;
    }


    try {
      return new URL(
        url,
        window.location.origin
      ).href;

    } catch (error) {
      return '#';
    }
  }


  /* =========================================================
     CREATE CART ITEM HTML
  ========================================================= */

  function createCartItemHTML(item) {

    const key =
      String(item.key || '');


    const title =
      String(
        item.product_title ||
        item.title ||
        ''
      );


    const variant =
      String(
        item.variant_title || ''
      );


    const url =
      getCartItemURL(item);


    const image =
      getCartImage(item);


    const quantity =
      Number(
        item.quantity || 1
      );


    const price =
      Number(
        item.final_line_price
          ? item.final_line_price / quantity
          : (
              item.final_price ||
              item.price ||
              0
            )
      );


    return `
      <article
        class="emp-cart-item"
        data-cart-item="${escapeHTML(key)}"
      >

        <a
          href="${escapeHTML(url)}"
          class="emp-cart-item__image"
          aria-label="${escapeHTML(title)}"
        >

          ${
            image
              ? `
                <img
                  src="${escapeHTML(image)}"
                  alt="${escapeHTML(title)}"
                  loading="eager"
                  width="180"
                  height="180"
                >
              `
              : `
                <div
                  class="emp-cart-item__image-placeholder"
                ></div>
              `
          }

        </a>


        <div class="emp-cart-item__content">

          <div class="emp-cart-item__details">

            <h3>
              ${escapeHTML(title)}
            </h3>


            ${
              variant &&
              variant !== 'Default Title'
                ? `
                  <p class="emp-cart-item__variant">
                    ${escapeHTML(variant)}
                  </p>
                `
                : ''
            }


            <div class="emp-cart-item__price">

              ${formatMoney(price)}

              <span class="emp-cart-item__multiply">
                ×
              </span>

              <span
                data-cart-quantity-text="${escapeHTML(key)}"
              >
                ${quantity}
              </span>

            </div>


            <div class="emp-cart-item__actions">

              <div
                class="emp-cart-quantity"
                aria-label="Quantity"
              >

                <button
                  type="button"
                  class="emp-cart-quantity__button"
                  data-cart-decrease="${escapeHTML(key)}"
                  aria-label="Decrease quantity"
                >
                  −
                </button>


                <span
                  class="emp-cart-quantity__value"
                  data-cart-quantity="${escapeHTML(key)}"
                >
                  ${quantity}
                </span>


                <button
                  type="button"
                  class="emp-cart-quantity__button"
                  data-cart-increase="${escapeHTML(key)}"
                  aria-label="Increase quantity"
                >
                  +
                </button>

              </div>


              <button
                type="button"
                class="emp-cart-item__remove"
                data-cart-remove="${escapeHTML(key)}"
              >
                Remove
              </button>

            </div>

          </div>

        </div>

      </article>
    `;
  }


  /* =========================================================
     RENDER CART
  ========================================================= */

  function renderCartDrawer(cart) {

    const cartDrawer =
      getDrawer();

    if (!cartDrawer) {
      return;
    }


    const itemsContainer =
      cartDrawer.querySelector(
        '[data-cart-items]'
      );


    const emptyBlock =
      cartDrawer.querySelector(
        '[data-cart-empty]'
      );


    const noteBlock =
      cartDrawer.querySelector(
        '[data-cart-note-block]'
      );


    const summaryBlock =
      cartDrawer.querySelector(
        '[data-cart-summary]'
      );


    const checkoutBlock =
      cartDrawer.querySelector(
        '[data-cart-checkout-block]'
      );


    const benefitsBlock =
      cartDrawer.querySelector(
        '[data-cart-benefits]'
      );


    const subtotal =
      cartDrawer.querySelector(
        '[data-cart-subtotal]'
      );


    if (!itemsContainer) {
      return;
    }


    const hasItems =
      Number(
        cart?.item_count || 0
      ) > 0;


    /* =====================================================
       VISIBILITY
    ===================================================== */

    itemsContainer.style.display =
      hasItems ? '' : 'none';


    if (noteBlock) {
      noteBlock.style.display =
        hasItems ? '' : 'none';
    }


    if (summaryBlock) {
      summaryBlock.style.display =
        hasItems ? '' : 'none';
    }


    if (checkoutBlock) {
      checkoutBlock.style.display =
        hasItems ? '' : 'none';
    }


    if (benefitsBlock) {
      benefitsBlock.style.display =
        hasItems ? '' : 'none';
    }


    if (emptyBlock) {
      emptyBlock.style.display =
        hasItems ? 'none' : '';
    }


    /* =====================================================
       ITEMS
    ===================================================== */

    if (hasItems) {

      itemsContainer.innerHTML =
        (cart.items || [])
          .map(
            createCartItemHTML
          )
          .join('');


      if (subtotal) {
        subtotal.textContent =
          formatMoney(
            cart.total_price
          );
      }


      /*
       * Update order note
       */

      const textarea =
        cartDrawer.querySelector(
          '[data-cart-note]'
        );

      if (
        textarea &&
        document.activeElement !== textarea
      ) {
        textarea.value =
          cart.note || '';
      }

    } else {

      itemsContainer.innerHTML = '';

    }


    /* =====================================================
       UPDATE COUNT
    ===================================================== */

    updateCartCount(cart);
  }


  /* =========================================================
     GET CART
  ========================================================= */

  async function getCart() {

    const response =
      await fetch(
        `${shopifyRoot()}cart.js`,
        {
          method: 'GET',

          headers: {
            Accept:
              'application/json'
          },

          cache: 'no-store'
        }
      );


    if (!response.ok) {
      throw new Error(
        'Unable to get cart.'
      );
    }


    return response.json();
  }


  /* =========================================================
     REFRESH CART
  ========================================================= */

  async function refreshCart() {

    try {

      const cart =
        await getCart();

      renderCartDrawer(cart);

      return cart;

    } catch (error) {

      console.error(
        'Cart refresh failed:',
        error
      );

      return null;
    }
  }


  /* =========================================================
     OPEN + REFRESH
  ========================================================= */

  async function openCart() {

    /*
     * OPEN IMMEDIATELY.
     */

    openCartDrawer();


    /*
     * Load cart after drawer
     * is already visible.
     */

    await refreshCart();
  }


  /* =========================================================
     ADD TO CART
  ========================================================= */

  async function addToCart(form) {

    if (
      addToCartUpdating ||
      !form
    ) {
      return;
    }


    addToCartUpdating = true;


    const button =
      form.querySelector(
        '[type="submit"], [data-add-to-cart]'
      );


    const originalHTML =
      button?.innerHTML || '';


    try {

      if (button) {
        button.disabled = true;
        button.classList.add('loading');

        button.setAttribute(
          'aria-busy',
          'true'
        );
      }


      const formData =
        new FormData(form);


      /*
       * IMPORTANT:
       * Add the selected variant.
       */

      let variantId =
        formData.get('id');


      if (!variantId) {

        const variantInput =
          form.querySelector(
            '[name="id"]'
          );

        if (variantInput) {
          variantId =
            variantInput.value;
        }
      }


      if (!variantId) {

        throw new Error(
          'No product variant selected.'
        );
      }


      /*
       * Shopify cart add.
       */

      const response =
        await fetch(
          `${shopifyRoot()}cart/add.js`,
          {
            method: 'POST',

            headers: {
              Accept:
                'application/json',

              'X-Requested-With':
                'XMLHttpRequest'
            },

            body: formData
          }
        );


      if (!response.ok) {

        let errorMessage =
          'Unable to add product to cart.';


        try {

          const errorData =
            await response.json();

          errorMessage =
            errorData.description ||
            errorData.message ||
            errorMessage;

        } catch (error) {
          /* Ignore JSON parse error */
        }


        throw new Error(
          errorMessage
        );
      }


      /*
       * Shopify has added the item.
       */

      await response.json();


      /*
       * OPEN DRAWER IMMEDIATELY.
       */

      openCartDrawer();


      /*
       * Then fetch the actual cart.
       */

      await refreshCart();


    } catch (error) {

      console.error(
        'Add to cart failed:',
        error
      );


      /*
       * Don't leave the user with
       * a dead button.
       */

      alert(
        error.message ||
        'Unable to add product to cart.'
      );


    } finally {

      addToCartUpdating = false;


      if (button) {

        button.disabled = false;

        button.classList.remove(
          'loading'
        );

        button.removeAttribute(
          'aria-busy'
        );

        if (originalHTML) {
          button.innerHTML =
            originalHTML;
        }
      }
    }
  }


  /* =========================================================
     ADD TO CART EVENT
  ========================================================= */

  document.addEventListener(
    'submit',
    async (event) => {

      const form =
        event.target.closest(
          'form'
        );


      if (!form) {
        return;
      }


      /*
       * Only intercept product
       * forms.
       */

      const variantInput =
        form.querySelector(
          '[name="id"]'
        );


      const addButton =
        form.querySelector(
          '[data-add-to-cart]'
        );


      const isProductForm =
        form.matches(
          '[data-product-form]'
        ) ||
        form.matches(
          '.product-form'
        ) ||
        form.classList.contains(
          'featured-cart-form'
        ) ||
        !!variantInput ||
        !!addButton;


      if (!isProductForm) {
        return;
      }


      /*
       * Do NOT intercept newsletter,
       * contact, search, etc.
       */

      if (
        form.closest(
          '#EmpCartDrawer'
        )
      ) {
        return;
      }


      event.preventDefault();
      event.stopPropagation();


      await addToCart(form);

    },
    true
  );


  /* =========================================================
     HEADER / CART BUTTON
  ========================================================= */

  document.addEventListener(
    'click',
    (event) => {

      const cartButton =
        event.target.closest(
          '[data-cart-drawer-open], .emp-cart'
        );


      if (!cartButton) {
        return;
      }


      event.preventDefault();
      event.stopPropagation();


      openCart();

    },
    true
  );


  /* =========================================================
     CLOSE DRAWER
  ========================================================= */

  document.addEventListener(
    'click',
    (event) => {

      const closeButton =
        event.target.closest(
          '[data-cart-drawer-close]'
        );


      if (!closeButton) {
        return;
      }


      event.preventDefault();

      closeCartDrawer();

    }
  );


  /* =========================================================
     ESCAPE
  ========================================================= */

  document.addEventListener(
    'keydown',
    (event) => {

      if (
        event.key === 'Escape'
      ) {
        closeCartDrawer();
      }

    }
  );


  /* =========================================================
     QUANTITY / REMOVE
  ========================================================= */

  document.addEventListener(
    'click',
    async (event) => {

      const increase =
        event.target.closest(
          '[data-cart-increase]'
        );


      const decrease =
        event.target.closest(
          '[data-cart-decrease]'
        );


      const remove =
        event.target.closest(
          '[data-cart-remove]'
        );


      let key = null;
      let quantity = null;


      /* =====================================================
         INCREASE
      ===================================================== */

      if (increase) {

        key =
          increase.getAttribute(
            'data-cart-increase'
          );


        const item =
          increase.closest(
            '[data-cart-item]'
          );


        const current =
          item?.querySelector(
            '[data-cart-quantity]'
          );


        quantity =
          Number(
            current?.textContent.trim() ||
            0
          ) + 1;
      }


      /* =====================================================
         DECREASE
      ===================================================== */

      else if (decrease) {

        key =
          decrease.getAttribute(
            'data-cart-decrease'
          );


        const item =
          decrease.closest(
            '[data-cart-item]'
          );


        const current =
          item?.querySelector(
            '[data-cart-quantity]'
          );


        quantity =
          Math.max(
            Number(
              current?.textContent.trim() ||
              1
            ) - 1,
            0
          );
      }


      /* =====================================================
         REMOVE
      ===================================================== */

      else if (remove) {

        key =
          remove.getAttribute(
            'data-cart-remove'
          );

        quantity = 0;
      }


      if (
        !key ||
        quantity === null
      ) {
        return;
      }


      event.preventDefault();


      await changeCartItem(
        key,
        quantity
      );

    }
  );


  /* =========================================================
     CHANGE CART ITEM
  ========================================================= */

  async function changeCartItem(
    key,
    quantity
  ) {

    if (cartUpdating) {
      return;
    }


    cartUpdating = true;


    try {

      const response =
        await fetch(
          `${shopifyRoot()}cart/change.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              id: key,
              quantity: quantity
            })
          }
        );


      if (!response.ok) {
        throw new Error(
          'Cart update failed.'
        );
      }


      const cart =
        await response.json();


      renderCartDrawer(cart);


    } catch (error) {

      console.error(
        'Cart quantity error:',
        error
      );


      await refreshCart();


    } finally {

      cartUpdating = false;
    }
  }


  /* =========================================================
     ORDER NOTE TOGGLE
  ========================================================= */

  document.addEventListener(
    'click',
    (event) => {

      const toggle =
        event.target.closest(
          '[data-cart-note-toggle]'
        );


      if (!toggle) {
        return;
      }


      const cartDrawer =
        getDrawer();


      if (!cartDrawer) {
        return;
      }


      const content =
        cartDrawer.querySelector(
          '[data-cart-note-content]'
        );


      if (!content) {
        return;
      }


      const isOpen =
        content.classList.contains(
          'is-open'
        );


      content.classList.toggle(
        'is-open',
        !isOpen
      );


      toggle.classList.toggle(
        'is-open',
        !isOpen
      );


      toggle.setAttribute(
        'aria-expanded',
        String(!isOpen)
      );
    }
  );


  /* =========================================================
     SAVE ORDER NOTE
  ========================================================= */

  document.addEventListener(
    'click',
    async (event) => {

      const save =
        event.target.closest(
          '[data-cart-note-save]'
        );


      if (!save) {
        return;
      }


      const cartDrawer =
        getDrawer();


      if (!cartDrawer) {
        return;
      }


      const textarea =
        cartDrawer.querySelector(
          '[data-cart-note]'
        );


      if (!textarea) {
        return;
      }


      save.disabled = true;


      const originalText =
        save.textContent;


      save.textContent =
        'Saving...';


      try {

        const response =
          await fetch(
            `${shopifyRoot()}cart/update.js`,
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                Accept:
                  'application/json'
              },

              body: JSON.stringify({
                note:
                  textarea.value
              })
            }
          );


        if (!response.ok) {
          throw new Error(
            'Note update failed.'
          );
        }


        save.textContent =
          'Saved';


        setTimeout(() => {

          save.textContent =
            originalText ||
            'Save note';

          save.disabled =
            false;

        }, 1200);


      } catch (error) {

        console.error(
          'Cart note error:',
          error
        );


        save.textContent =
          'Try again';

        save.disabled =
          false;
      }
    }
  );


  /* =========================================================
     INITIAL CART LOAD
  ========================================================= */

  async function init() {

    getDrawer();

    /*
     * Only refresh if drawer exists.
     */

    if (getDrawer()) {
      await refreshCart();
    }
  }


  /* =========================================================
     PUBLIC API
  ========================================================= */

  window.EmpCart = {

    open: openCartDrawer,

    close: closeCartDrawer,

    refresh: refreshCart,

    openAndRefresh: openCart,

    add: async function(form) {
      return addToCart(form);
    }

  };


  /* =========================================================
     INITIALIZE
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );

  } else {

    init();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    () => {
      drawer = null;
      init();
    }
  );


  document.addEventListener(
    'shopify:section:reorder',
    () => {
      drawer = null;
      init();
    }
  );


})();